import React from "react";
import Home from "../pages/home";
import Page from "@jumbo/shared/Page";
import Meeting from "app/pages/meeting/listMeeting";
import ListMeeting from "app/pages/meeting/listMeeting";
import ListUnit from "app/pages/references/listUnit";
import ListSubject from "app/pages/references/listSubject";
import ManagementMeeting from "app/pages/meeting/managementMeeting";
import RoleManagementPage from "app/pages/management/RoleManagementPage";
import AddMeetingPage from "app/pages/meeting/addMeetingPage";
import RoleUserParticipantManPage from "app/pages/management/RoleUserParticipantManPage";
import ReviewPage from "app/pages/dashboard/ReviewPage";
import VotePage from "app/pages/dashboard/VotePage";
import PreviousPage from "app/pages/dashboard/PreviousPage";
import DecisionStatusPage from "app/pages/meeting/decisionStatusPage";
import RoleDstatusPage from "app/pages/management/RoleDstatusPage";
import AttendedMeetings from "app/pages/meeting/attendedMeetings";
import PendingAgendasPage from "app/pages/meeting/pendingAgendasPage";
import ReportSubjectGroupsPage from "app/pages/reports/reportSubjectGroupsPage";
import ReportDecisionCountInfoPage from "app/pages/reports/reportDecisionCountInfoPage";
import ReportMeetingUsersInfoPage from "app/pages/reports/reportMeetingUsersInfoPage";
import UploadPeriodicReportPage from "app/pages/UploadPeriodicReportPage";
import CustomEpostaListPage from "app/pages/management/CustomEpostaListPage";
import DetailSearchPage from "app/pages/dashboard/DetailSearchPage";
import WatchingMeetingPage from "app/pages/meeting/watchingMeetingPage";
import EducationVideosPage from "app/pages/education/educationVideosPage";
import ListAnnouncement from "app/pages/references/listAnnouncement";
import RoleReportingPage from "app/pages/management/RoleReportingPage";
import ReportUnitCountPage from "app/pages/reports/reportUnitCountPage";
import ReportBoardMemberPage from "app/pages/reports/reportBoardMemberPage";
import AgendaTemplatePage from "app/pages/references/AgendaTemplatePage";
import ReportAuthorityListPage from "app/pages/reports/ReportAuthorityListPage";
import ReportYKKPage from "app/pages/reports/reportYKKPage";
import ReportDecisionsReportPage from "app/pages/reports/reportDecisionsReportPage";
import ArchivePage from "app/pages/meeting/archivePage";


const routesForPublic = [
    {
        path: "/",
        element: <Page component={Home} />
    },
    {
        path: "/meeting",
        element: <Page component={Meeting} />
    },
    {
        path: "/listMeeting/:pageType?",
        element: <Page component={ListMeeting} />,
    },
    {
        path: "/managementMeeting/:pageType/:subType?",
        element: <Page component={ManagementMeeting} />,
    },
    {
        path: "/listUnit",
        element: <Page component={ListUnit} />,
    },
    {
        path: "/listSubject",
        element: <Page component={ListSubject} />,
    },
    {
        path: "/RoleManagementPage",
        element: <Page component={RoleManagementPage} />,
    },
    {
        path: "/addMeetingPage/:pageType?",
        element: <Page component={AddMeetingPage} />,
    },
    {
        path: "/RoleUserParticipantManPage",
        element: <Page component={RoleUserParticipantManPage} />,
    },
    {
        path: "/reviewPage",
        element: <Page component={ReviewPage} />,
    },
    {
        path: "/votePage",
        element: <Page component={VotePage} />,
    },
    {
        path: "/previousPage/:page?", // :page? isteğe bağlı bir parametre
        element: <Page component={PreviousPage} />,
    },
    {
        path: "/decisionStatusPage/:param?",
        element: <Page component={DecisionStatusPage} />,
    },
    {
        path: "/RoleDstatusPage",
        element: <Page component={RoleDstatusPage} />,
    },
    {
        path: "/attendedMeetings/:pageType?",
        element: <Page component={AttendedMeetings} />,
    },
    {
        path: "/pendingAgendasPage",
        element: <Page component={PendingAgendasPage} />,
    },
    {
        path: "/reportSubjectGroupsPage",
        element: <Page component={ReportSubjectGroupsPage} />,
    },
    {
        path: "/reportDecisionCountInfoPage",
        element: <Page component={ReportDecisionCountInfoPage} />,
    },
    {
        path: "/reportMeetingUsersInfoPage",
        element: <Page component={ReportMeetingUsersInfoPage} />,
    },
    {
        path: "/UploadPeriodicReportPage",
        element: <Page component={UploadPeriodicReportPage} />,
    },
    {
        path: "/CustomEpostaListPage",
        element: <Page component={CustomEpostaListPage} />,
    },
    {
        path: "/DetailSearchPage",
        element: <Page component={DetailSearchPage} />,
    },
    {
        path: "/watchingMeetingPage",
        element: <Page component={WatchingMeetingPage} />,
    },
    {
        path: "/educationVideosPage",
        element: <Page component={EducationVideosPage} />,
    },
    {
        path: "/listAnnouncement",
        element: <Page component={ListAnnouncement} />,
    },
    {
        path: "/RoleReportingPage",
        element: <Page component={RoleReportingPage} />,
    },
    {
        path: "/reportUnitCountPage",
        element: <Page component={ReportUnitCountPage} />,
    },
    {
        path: "/reportBoardMemberPage",
        element: <Page component={ReportBoardMemberPage} />,
    },
    {
        path: "/agendaTemplatePage",
        element: <Page component={AgendaTemplatePage} />,
    },
    {
        path: "/reportAuthorityListPage",
        element: <Page component={ReportAuthorityListPage} />,
    },
    {
        path: "/reportYKKPage",
        element: <Page component={ReportYKKPage} />,
    },
    {
        path: "/reportDecisionsReportPage",
        element: <Page component={ReportDecisionsReportPage} />,
    },
    {
        path: "/archivePage",
        element: <Page component={ArchivePage} />,
    }
];

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [];


const routes = [
    ...routesForPublic,
    ...routesForAuthenticatedOnly,
    ...routesForNotAuthenticatedOnly,
];

export { routes as default, routesForPublic, routesForNotAuthenticatedOnly, routesForAuthenticatedOnly };